<template>
  <div class="page withdraw-preview">
    <!-- 导航条 -->
    <navigation type="second-level" :sticky="true">展期订单申请</navigation>
    <div class="noticeBar">请确认信息真实及完整性，用于本次展期订单申请</div>
    <common :index="1"/>
    <!-- 新订单申请 -->
    <section class="card-panel">
      <nd-cell
        class="info-line"
        :arrow="false"
        title="申请展期总额 (元)"
      ><span slot="text" style="color: #FF3446">{{form.applyAmt|currency}}</span></nd-cell>
      <!-- <nd-cell
        class="info-line"
        :arrow="false"
        title="怎么花"
        :text="form.purpose|filterPurpse"
      ></nd-cell> -->

      <nd-cell
        class="info-line"
        :arrow="false"
        title="分几期"
        :text="`${form.applyTerm}期`"
      ></nd-cell>
    </section>
    <section class="bottom">
      <!-- 相关协议 -->
      <nd-button
        class="withdraw-btn"
        @click="nextStep"
      >下一步：展期订单预览申请</nd-button>
      <section class="read-protocol">
        <span>综合年化利率以实际每笔订单放款审核为准</span>
      </section>
    </section>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import common from './components/common'
import { getKey } from '../../../assets/utils'
export default {
  name: 'repayment-consult-apply',

  description: '展期订单申请',

  components: {
    common
  },
  customReadyNotify: true,
  data () {
    return {
      orderId: this.$route.query.orderId,
      form: {
        // 提现表单
        applyAmt: '',
        applyTerm: '',
        purpose: ''
      },
      loanPlatform: this.$route.query.loanPlatform || 'TMD',
      originalPlatBillNo: ''
    }
  },
  async created () {
    await this.consultX()
    this.$bus.$emit('ready')
  },
  filters: {
    filterPurpse (value = {}) {
      return value.description || ''
    }
  },
  methods: {
    ...mapActions('repay', ['consult', 'consultPreview', 'queryElement']),
    // 获取订单数据
    async consultX () {
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      const { success, data } = await this.consult({
        originalPlatBillNo: this.orderId,
        loanPlatform: this.loanPlatform,
        productCode: 'TMDE',
        ...trafficCode
      })

      if (success) {
        const { loanPrin, loanTerm, loanPurpose, originalPlatBillNo } = data || {}
        this.form.applyAmt = loanPrin
        this.form.applyTerm = loanTerm
        this.form.purpose = loanPurpose
        this.originalPlatBillNo = originalPlatBillNo
      }
    },
    // 跳转下一步
    async  nextStep () {
      let trafficCode = getKey('channel') ? { trafficCode: getKey('channel') } : {}
      const { applyAmt, applyTerm, purpose = {} } = this.form || {}
      const response = await this.consultPreview({
        originalPlatBillNo: this.originalPlatBillNo,
        applyAmount: applyAmt,
        applyTerm: applyTerm,
        loanPurpose: purpose.key,
        loanPlatform: this.loanPlatform,
        ...trafficCode
      })
      if (response.success) {
        const { fundCode, originalPlatBillNo, termInfo, intRate, interestFee, originalBillBank } = response.data || {}
        let consultApply = {
          termInfo,
          intRate,
          interestFee,
          originalBillBank,
          applyAmt,
          applyTerm,
          purpose,
          originalPlatBillNo
        }
        localStorage.setItem('consultApply', JSON.stringify(consultApply))
        this.$router.push({ path: '/repayment/consult/preview', query: { fundCode } })
      } else {
        if (response.code === '100011') {
          this.$message('展期申请已关闭，借据已回归正常状态，如有疑问，请联系客服；')
          this.$router.go(-3)
          return
        }
        if (response.code === '100003') {
          this.$message(response.msg)
        }
        let status = this.judge(response.code)
        // 状态为3的时候不传入count
        if (status !== null) {
          let poorData = await this.queryElement()
          let count = ''
          if (poorData.success) {
            const { idCardExpireDays, applyMinTime, applyMaxTime } = poorData.data || {}
            if (status === 'aboutToExpire') {
              count = idCardExpireDays
            } else {
              count = `${applyMinTime}-${applyMaxTime}`
            }
          }
          return this.$router.push({
            path: '/withdraw/poor-credit',
            query: {
              status,
              source: 'XIESHANG',
              count,
              orderId: this.orderId,
              loanPlatform: this.loanPlatform,
              title: '展期订单申请'
            }
          })
        }
      }
    },
    // 判断跳转状态
    // 跳转到其它界面传参 unsatisfied:贷后还款表现不满足放款 time当前时间系统暂不支持提现 failed身份信息验证失败，暂不支持提现 expired身份证信息已到期，需重新上传 aboutToExpire您的身份证信息30天内即将过期
    judge (canLoanCode) {
      let status = null
      switch (canLoanCode) {
        case '000054':
          status = 'time'
          break
        case '000051':
          status = 'failed'
          break
        case '000023':
          status = 'expired'
          break
        case '000052':
          status = 'aboutToExpire'
          break
        default:
          status = null
      }
      return status
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes shine {
    0% {
        background-color: #ffddd9;
    }
    20% {
        background-color: #ffffff;
    }
    40% {
        background-color: #ffddd9;
    }
    60% {
        background-color: #ffffff;
    }
    80% {
        background-color: #ffddd9;
    }
    100% {
        background-color: #ffffff;
    }
}
.through{
    text-decoration: line-through;
    padding-right:15px;
}
.noticeBar{
    width: 750px;
    height: 70px;
    background: #FFF9F1;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF8864;
    line-height: 33px;
    display:flex;
    align-items: center;
    justify-content:center;
}
.withdraw-preview {
    padding-bottom: 325px;
    min-height: 100%;
    box-sizing: border-box;
    background-color: RGBA(250, 250, 250, 1);

    .card-panel {
        margin-top: 20px;

        .info-line {
            height: 100px;
            line-height: 100px;
            border-bottom: 1px solid #eee;
            position: relative;
            margin-bottom: 1px;
            font-size: 30px;
            color: rgba(51, 51, 51, 1) !important;
            &:last-child {
                animation: shine 2000ms step-end;
            }

            .custom-icon {
                display: block;
                width: 30px;
                height: 30px;
                background-size: 100%;
                float: right;
                position: relative;
                top: 35px;
                margin-left: 10px;
            }

            .weight {
                font-size: 34px;
                font-family: PingFangSC-Semibold;
                font-weight: 600;
                color: #20c7c7;
            }
        }
        .info-other{
            width: 100%;
            background-color: #fff;
            margin-top: 21px;
            padding: 28px 30px;
            .other-title{
                color: #333333;
                font-size: 30px;
            }
            .other-money{
                color: #999999;
                font-size: 26px;
                margin-top: 15px;
            }
            .other-rate{
                color: #999999;
                font-size: 26px;
                margin-top: 10px;
                .other-img{
                    width: 26px;
                    height: 26px;
                    vertical-align: -3px;
                }
            }
        }
    }
    .repayment-schedule {
        margin: 40px 30px 0;
        border-radius: 10px;
        &.b {
            background-color: #fff;
            .cell-title {
                padding: 33px 40px;
                .show-detail {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: rgba(142, 178, 216, 1);
                    line-height: 50px;
                    > img {
                        width: 29px;
                        height: 29px;
                        margin-left: 8px;
                        transition: all .3s;
                    }
                }
            }
        }
        .cell-title {
            font-size: 32px;
            line-height: 50px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;

            em {
                font-size: 26px;
                font-style: normal;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: @fc3;
            }
        }

        .schedule-list {
            margin-top: 22px;
            padding-bottom: 20px;
            background-color: #ffffff;
            border-radius: 10px;
            table {
                width: 100%;
                border-spacing: 0px;

                .table-header {
                    th {
                        font-size: 27px;
                        height: 50px;
                        line-height: 50px;
                        padding-top: 23px;
                        padding-bottom: 7px;
                        border-bottom: 1px solid @iuc;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }
                }

                .table-row {
                    td {
                        height: 50px;
                        line-height: 50px;
                        font-size: 22px;
                        padding-top: 10px;
                        text-align: center;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                    }

                    & + .table-row {
                        td {
                            padding-top: 2px;
                        }
                    }
                }
            }
        }
    }

    > .bottom {
        width: 750px;
        height: 230px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.04);
        position: fixed;
        bottom: 0;
        .read-protocol {
            width: 100%;
            text-align: center;
            margin-top: 25px;
            span {
                font-family: 'PingFangSC-Regular';
                font-weight: 400;
                color: #666;
                font-size: 24px;
                line-height: 33px;
                display: block;
                em {
                    font-style: normal;
                    color: rgba(142, 178, 216, 1);
                    margin-left: 5px;
                    margin-right: 5px;
                }
            }
        }
        .withdraw-btn {
            width: 650px;
            height: 94px;
            border-radius: 47px;
            margin: 30px auto 0;
        }
    }

    .auth-dialog {
        .default-content {
            width: 620px;
            border-radius: 30px 30px 0 0;
            padding-top: 40px;
            background: white;
            height: 638px;
            overflow: auto;
            .dialog-title {
                text-align: center;
                font-size: 36px;
                padding-bottom: 15px;
                font-weight: 600;
            }

            .dialog-footer {
                padding: 0 50px;
                padding-bottom: 40px;
                display: flex;
                justify-content: space-between;
                background-color: #FFFFFF;

                .btn {
                    width: 240px;
                    height: 80px;
                    line-height: 80px;
                }
            }
        }
        .iframe {
            height: 638px;
            width: 100%;

            html {
                width: 100%;
            }
        }

        .btn-wrapper {
            position: fixed;
            background: white;
            height: 162px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width:620px;
            border-radius:  0 0 30px 30px;
            transform: translateY(-20px);
            .btn {
                width: 500px;
            }
        }
    }
    /deep/ .rate-tips-title{
        font-size: 42px;
        color: #333333;
        font-weight: bold;
        padding-left: 40px;
    }
    .rate-tips-dialog{
        padding: 40px 40px 60px;
        color: #666666;
        font-size: 28px;
    }
}
</style>
